import { render, staticRenderFns } from "./MonthlyReport.vue?vue&type=template&id=64d50222&scoped=true"
import script from "./MonthlyReport.vue?vue&type=script&lang=js"
export * from "./MonthlyReport.vue?vue&type=script&lang=js"
import style0 from "./MonthlyReport.vue?vue&type=style&index=0&id=64d50222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d50222",
  null
  
)

export default component.exports